export default __webpack_public_path__ + "static/media/Sapphires.a849b67a.png";